var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineSearch',{staticClass:"item-picker-search",attrs:{"value":_vm.searchTerm,"placeholder":_vm.placeholder,"focus-on-mount":"","show-icon":""},on:{"input":_vm.onSearchChange}})}
var staticRenderFns = []

export { render, staticRenderFns }